module.exports = {"530724001":"大兴街道","530724002":"紫玛街道","530724102":"永宁镇","530724103":"红桥镇","530724104":"战河镇","530724201":"拉伯乡","530724203":"翠玉傈僳族普米族乡","530724205":"宁利乡","530724206":"金棉乡","530724207":"西川乡","530724208":"西布河乡","530724210":"永宁坪乡","530724211":"跑马坪乡","530724212":"蝉战河乡","530724213":"新营盘乡","530724214":"烂泥箐乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530724.json
// module id = 2730
// module chunks = 0